import React from "react";
import { useTranslation } from "react-i18next";
import { DataTable } from "@/components/DataTable";
import { Share } from "lucide-react";
import { toast } from "sonner";
import { useLiveEventFilterOptions } from "@/pages/GamesAndLiveEventsOverview/hooks/useLiveEventFilterOptions";
import { ChatChannel } from "@/__generated__/types";

interface TableHeaderProps {
  onFilterChange: (filterId: string, values: string[]) => void;
  filterDisplayValue: string;
  availableChatChannels: ChatChannel[];
}

export const TableHeader: React.FC<TableHeaderProps> = ({
  onFilterChange,
  filterDisplayValue,
  availableChatChannels = [],
}) => {
  const { t } = useTranslation();

  const filterOptions = useLiveEventFilterOptions(availableChatChannels);

  const handleShare = async () => {
    try {
      await navigator.clipboard.writeText(window.location.href);
      toast.success(
        t("gamesLiveEvents.communityToolsOverview.actions.shareToast.success"),
      );
    } catch (error) {
      console.error("Failed to copy to clipboard:", error);
    }
  };

  return (
    <div className="flex w-full items-start justify-between p-6 pr-0">
      <DataTable.Title
        title={t(
          "gamesLiveEvents.communityToolsOverview.tabs.gamesLiveEvents.title",
        )}
        description={t(
          "gamesLiveEvents.communityToolsOverview.tabs.gamesLiveEvents.subtitle",
        )}
        className="p-0"
      />
      <div className="flex flex-shrink-0 gap-2">
        <DataTable.Filter
          customFilters={filterOptions}
          onFilterChange={onFilterChange}
          displayValue={filterDisplayValue}
        />
        <DataTable.HeaderActions
          actions={[
            /* Disable for now
            {
              key: "export-csv",
              render: () => (
                <>
                  <FileDown
                    className="mr-2 h-4 w-4"
                    aria-label={t(
                      "gamesLiveEvents.communityToolsOverview.actions.exportCsv",
                    )}
                  />
                  {t(
                    "gamesLiveEvents.communityToolsOverview.actions.exportCsv",
                  )}
                </>
              ),
              onClick: () => {
                console.log("Implement CSV export");
              },
            },
            */
            {
              key: "share",
              render: () => (
                <>
                  <Share
                    className="mr-2 h-4 w-4"
                    aria-label={t(
                      "gamesLiveEvents.communityToolsOverview.actions.share",
                    )}
                  />
                  {t("gamesLiveEvents.communityToolsOverview.actions.share")}
                </>
              ),
              onClick: handleShare,
            },
          ]}
        />
      </div>
    </div>
  );
};
